export const fetchSunburtData = async (request, payload) => {
    try {
        const response = await request("POST", `/v1/survey/dashboard/sun-burst`,{ data: { "locationId": payload.locationId, "surveyId": payload.surveyId, "type": payload.type } }, "survey_service");
        return response;

    } catch (error) {
        console.log(error)
    }

};